import React from 'react';
import { images } from '../../assets';
import { useSmoothScroll } from '../../motion/SmoothScroll';

const INSTAGRAM_URL =
  'https://www.instagram.com/the.studio.vs._?igsh=MXN6Yncxcmh5M2t3Nw%3D%3D&utm_source=qr';

const Footer = () => {
  const { scrollTo, lenis } = useSmoothScroll() || {};

  const scrollToTop = (e) => {
    e.preventDefault();
    if (lenis) {
      lenis.scrollTo(0, { duration: 1.2 });
    } else if (scrollTo) {
      scrollTo('#top');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      <footer className="template-footer">
        <div className="instagram-line">
          <div className="container">
            <ul className="insta-list">
              {images.instagram.map((image, index) => (
                <li key={index}>
                  <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`Follow TheStudioVS on Instagram - image ${index + 1}`}
                  >
                    <img src={image} alt={`Instagram ${index + 1}`} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="widget-part-area">
          <div className="container">
            <div className="row footer-links-row">
              <div className="col-lg-4">
                <div className="footer-widget-line">
                  <span className="footer-eyebrow">Studio</span>
                  <h5>Location</h5>
                  <ul className="custom-list">
                    <li>
                      <a href="#contact">C-109, Sector 100, Noida</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer-widget-line">
                  <span className="footer-eyebrow">Online</span>
                  <h5>Connect</h5>
                  <ul className="custom-list">
                    <li>
                      <a
                        href="https://www.thestudiovs.com"
                        target="_blank"
                        rel="noreferrer"
                      >
                        www.thestudiovs.com
                      </a>
                    </li>
                    <li>
                      <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer">
                        @the.studio.vs._
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer-widget-line">
                  <span className="footer-eyebrow">Reach us</span>
                  <h5>Get in Touch</h5>
                  <ul className="custom-list">
                    <li>
                      <a href="mailto:info@thestudiovs.com">
                        info@thestudiovs.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:9211296162">9211296162</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="footer-last-line">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-sm-6">
              <p>&copy; TheStudioVS {new Date().getFullYear()}</p>
            </div>
            <div className="col-sm-6">
              <ul className="social-list">
                <li>
                  <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                    title="Instagram"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    className="go-top-inline"
                    href="#top"
                    onClick={scrollToTop}
                    aria-label="Back to top"
                    title="Back to top"
                  >
                    <i className="far fa-arrow-alt-circle-up"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
